import React from "react";
import { ArrowUpRight, Play, TrendingUp } from "lucide-react";
import { brand, stats } from "../mock";

export default function Hero() {
  return (
    <section id="top" className="relative pt-36 pb-24 overflow-hidden gt-radial-glow">
      <div className="absolute inset-0 gt-grid-bg opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="flex items-center gap-3 mb-8 gt-fadeup">
          <span className="gt-dot" />
          <span className="text-xs tracking-[0.32em] text-neutral-400 uppercase">
            Live cohort · High-ticket sales & English mastery
          </span>
        </div>

        <h1 className="gt-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] max-w-5xl gt-fadeup">
          Where <em className="not-italic gt-text-gradient">language</em>
          <br />
          meets <span className="text-emerald-400">revenue.</span>
        </h1>

        <p className="mt-8 max-w-2xl text-lg text-neutral-400 leading-relaxed gt-fadeup" style={{ animationDelay: "0.1s" }}>
          Global Tribe is a hybrid platform for operators, founders and closers who refuse to
          sound average and refuse to sell small. Built by an IIMK alum with a decade of
          million-dollar closings.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4 gt-fadeup" style={{ animationDelay: "0.2s" }}>
          <a href="#services" className="gt-btn-primary px-6 py-3.5 rounded-full inline-flex items-center gap-2">
            Explore Programs <ArrowUpRight className="w-4 h-4" />
          </a>
          <a href="#journey" className="gt-btn-ghost px-6 py-3.5 rounded-full inline-flex items-center gap-2">
            <Play className="w-4 h-4" /> The Story
          </a>
        </div>

        {/* Founder card */}
        <div className="mt-20 grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((s, i) => (
              <div
                key={s.label}
                className="gt-hairline gt-hover-lift rounded-2xl p-5 bg-white/[0.02] gt-fadeup"
                style={{ animationDelay: `${0.3 + i * 0.08}s` }}
              >
                <div className="gt-serif text-3xl md:text-4xl text-white">{s.value}</div>
                <div className="mt-2 text-xs text-neutral-400 leading-snug">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5">
            <div className="gt-hairline rounded-2xl overflow-hidden bg-gradient-to-br from-white/[0.04] to-transparent">
              <div className="flex items-center gap-4 p-5">
                <div className="relative">
                  <img
                    src="https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=400&q=70"
                    alt="Arnab Pramanik"
                    className="w-14 h-14 rounded-full object-cover ring-2 ring-emerald-400/40"
                  />
                  <span className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-emerald-400 border-2 border-[#0a0a0b]" />
                </div>
                <div className="flex-1">
                  <div className="text-sm text-white font-medium">{brand.founder}</div>
                  <div className="text-xs text-neutral-400">{brand.role}</div>
                </div>
                <TrendingUp className="w-5 h-5 text-emerald-400" />
              </div>
              <div className="border-t border-white/5 px-5 py-4 text-sm text-neutral-300 leading-relaxed">
                “I don’t teach theory. I teach the exact conversations that moved deals from
                <span className="text-emerald-400"> $40K to $1M+</span> — in rooms I’ve
                actually been in.”
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
